import { render, staticRenderFns } from "./BuckingHorse.vue?vue&type=template&id=88404928&"
import script from "./BuckingHorse.vue?vue&type=script&lang=ts&"
export * from "./BuckingHorse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports